import styled from 'styled-components';

export const Container = styled.div`
  .bg-message {
    background: ${(props) => props.theme.$bg_gray};
  }
  .message-keyword {
    background: ${(props) => props.theme.$warning};
    font-weight: bold;
  }
  .monitoring-date {
    font-size: 0.9em;
  }
`;
